<template>
  <div class="card-container">
    <common-top-form
      ref="commonTopForm"
      :needCheck="needCheck"
      selectShowPower="/accountsupervise/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="false"
      @check="handleTopCheck"
    >
      <el-form-item label="商户号">
        <el-input
          clearable
          type="text"
          maxlength="20"
          v-model="formModel.merCode"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
       <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.activeTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable"  @handleChange="getPage">
      <el-table-column
        prop="merCode"
        label="商户号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="shopSncode"
        label="SN"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="acqActiveCode"
        label="上游活动编号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="simDate"
        label="计划收取时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="succDate"
        label="实际收取时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
       <el-table-column
        prop="merSimAmt"
        label="收取金额"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="lowAmt"
        label="最小交易金额"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
           <el-table-column
        prop="status"
        label="收费状态"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
         <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未收费</span>
          <span v-else-if="scope.row.status == 1">已收费</span>
          <span v-else-if="scope.row.status == 2">不收费</span>
          <span v-else-if="scope.row.status == 3">收费失败</span>
        </template>
      </el-table-column>
           <el-table-column
        prop="orderCode"
        label="订单号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
           <el-table-column
        prop="simDays"
        label="收费周期（天数）"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '修改'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="100px"
    >
      <el-form-item label="代理商ID" prop="memId" label-width="120px">
        <el-input
          style="width: 180px"
          disabled
          type="text"
          maxlength="100"
          v-model="dialogModel.memId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="积分余额" prop="integralSum" label-width="120px">
        <el-input
          style="width: 180px"
          disabled
          type="text"
          maxlength="100"
          v-model="dialogModel.integralSum"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="分润账户余额" prop="withdrawSum" label-width="120px">
        <el-input
          style="width: 180px"
          disabled
          type="text"
          maxlength="100"
          v-model="dialogModel.withdrawSum"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="其他账户余额" prop="otherSum" label-width="120px">
        <el-input-number
          v-model="dialogModel.otherSum"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import OrganService from "service/OrganService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "accountsupervise",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      needCheck: true,
      formModel: {
        merCode: "",
        activeTime: ''
      },
      tableData: [],
      submitService: OrganService.AccountTopList,
      itemId: "",
      dialogModel: {
        memId: "",
        integralSum: "",
        withdrawSum: "",
        otherSum: undefined,
      },
      dialogRules: {
        otherSum: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
      isPage: false,
         page: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
          if (
        this.formModel.activeTime == null ||
        this.formModel.activeTime == ""
      ) {
        this.formModel.activeTime = [];
      }
      this.params = {
        merCode: this.formModel.merCode,
         current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.activeTime.length) {
        this.params.startDate = this.formModel.activeTime[0];
        this.params.endDate = this.formModel.activeTime[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        memId: this.dialogModel.memId,
        integralSum: this.dialogModel.integralSum,
        withdrawSum: this.dialogModel.withdrawSum,
        otherSum: this.dialogModel.otherSum,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? OrganService.accountsuperviseEdit
        : OrganService.accountsuperviseEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    getPage() {
         this.isPage = true;
      this.getList();
    },
    load() {
      this.formModel = {
        activeTime: '',
        merCode: ''
      };
       this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
             this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        memId: "",
        integralSum: "",
        withdrawSum: "",
        otherSum: undefined,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
          console.log(res,'res')
        const result = res.contents.rows;
        this.tableData = result;
         this.needCheck = true;
         this.page.currentPage = res.contents.current;
        this.page.total = res.contents.total;
        this.page.pageSize = res.contents.size;
       
      });
    },
    handleTopCheck() {
    //   if (!this.formModel.sn) {
    //     this.showWarming("请输入SN");
    //     return;
    //   }

      this.needCheck = false;
      this.$refs.commonTopForm.submit();
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/PosImplement/PosTopNew.vue